module.exports = __webpack_public_path__ + "media/views/about/images/time-15688a8650b3410dfb3817e4107b4740.svg";